// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calculator[data-v-5bb36e8e] {

    padding-top: 4rem;

    padding-bottom: 4rem;

    width: 100%;

    padding-right: 1rem;

    padding-left: 1rem;

    margin: auto;
}
@media (min-width: 640px) {
.calculator[data-v-5bb36e8e] {

        padding-right: 1.5rem;

        padding-left: 1.5rem;

        width: calc((100vw - 1.5rem) / 8 * 6 + 1.5rem);
}
}
@media (min-width: 996px) {
.calculator[data-v-5bb36e8e] {

        width: 100%;
}
}
@media (min-width: 1320px) {
.calculator[data-v-5bb36e8e] {

        max-width: 1320px;

        width: calc((1320px - 1.5rem) / 12 * 8 + 1.5rem);
}
}
@media (min-width: 1536px) {
.calculator[data-v-5bb36e8e] {

        width: 100%;
}
}
@media (min-width: 640px) {
.calculator[data-v-5bb36e8e] {

        padding-top: 5rem;

        padding-bottom: 5rem;
}
}
.calculator__container[data-v-5bb36e8e] {

    overflow: hidden;
}
@media (min-width: 996px) {
.calculator__container[data-v-5bb36e8e] {

        border-radius: 12px;

        border-width: 2px;

        border-style: solid;

        --tw-bg-opacity: 1;

        background-color: rgb(0 154 250 / var(--tw-bg-opacity));

        --tw-text-opacity: 1;

        color: rgb(0 154 250 / var(--tw-text-opacity));
}
}
.calculator__wrapper[data-v-5bb36e8e] {

    position: relative;

    border-radius: 12px;

    --tw-bg-opacity: 1;

    background-color: rgb(0 154 250 / var(--tw-bg-opacity));

    padding: 2.5rem 2rem;
}
@media (min-width: 996px) {
.calculator__wrapper[data-v-5bb36e8e] {

        border-radius: 0px;

        padding-top: 3.5rem;

        padding-bottom: 3.5rem;
}
}
@media (min-width: 1536px) {
.calculator__wrapper[data-v-5bb36e8e] {

        padding-left: 12.5rem;

        padding-right: 12.5rem;
}
}
.calculator__mole[data-v-5bb36e8e] {

    position: absolute;

    bottom: -98px;

    right: -98px;

    z-index: 0;

    display: none;

    height: 290px;

    width: 296px;

    --tw-rotate: 45deg;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

    border-top-left-radius: 260px;

    border-bottom-left-radius: 260px;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
@media (min-width: 996px) {
.calculator__mole[data-v-5bb36e8e] {

        display: block;
}
}
@media (min-width: 1536px) {
.calculator__mole[data-v-5bb36e8e] {

        bottom: -153px;

        right: -57px;

        width: 432px;
}
}
.calculator__content[data-v-5bb36e8e] {

    position: relative;

    z-index: 0;

    text-align: center;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (min-width: 996px) {
.calculator__content[data-v-5bb36e8e] {

        display: flex;

        align-items: center;

        text-align: left;
}
}
.calculator__image[data-v-5bb36e8e] {

    margin: auto;

    height: 102px;

    width: 102px;
}
@media (min-width: 996px) {
.calculator__body[data-v-5bb36e8e] {

        margin-left: 1.5rem;
}
}
.calculator__title[data-v-5bb36e8e] {

    margin-top: 1.5rem;

    font-family: Mont;

    line-height: 1.35;

    font-size: 2rem;

    font-weight: 700;
}
@media (min-width: 996px) {
.calculator__title[data-v-5bb36e8e] {

        margin-top: 0;
}
}
.calculator__text[data-v-5bb36e8e] {

    margin-left: auto;

    margin-right: auto;

    margin-top: 0.5rem;

    max-width: 17.5rem;

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400;
}
@media (min-width: 996px) {
.calculator__text[data-v-5bb36e8e] {

        max-width: 26.375rem;
}
}
.calculator__cta[data-v-5bb36e8e] {

    border-radius: 12px;

    font-family: Roboto;

    font-weight: 400;

    display: inline-block;

    text-align: center;

    cursor: pointer;
}
.calculator__cta[data-v-5bb36e8e]:disabled {

    color: #9CA3AF;
}
.calculator__cta[data-v-5bb36e8e] {

    background-color: #10213E;

    color: #FFFFFF;
}
.calculator__cta[data-v-5bb36e8e]:hover {

    background-color: #475A7D;

    color: #FFFFFF;
}
.calculator__cta[data-v-5bb36e8e]:disabled {

    background-color: #E5E7EB;
}
.btn-container .calculator__cta[data-v-5bb36e8e] {

    width: 100%;
}
@media (min-width: 640px) {
.btn-container .calculator__cta[data-v-5bb36e8e] {

        width: -moz-fit-content;

        width: fit-content;
}
}
.fotocasa .calculator__cta[data-v-5bb36e8e] {

    background-color: #303AB2;

    font-weight: 700;
}
.calculator__cta[data-v-5bb36e8e] {

    padding: 1rem 1.5rem;

    line-height: 1.35;

    font-size: 1.125rem;
}
.fotocasa .calculator__cta[data-v-5bb36e8e] {

    padding: 0.5rem 2rem;

    font-size: 15px;
}
.calculator__cta[data-v-5bb36e8e] {

    margin-left: auto;

    margin-right: auto;

    margin-top: 2.5rem;

    display: block;

    width: 100%;

    max-width: 460px;
}
@media (min-width: 996px) {
.calculator__cta[data-v-5bb36e8e] {

        margin-top: 0;

        margin-left: 5rem;

        width: 13.25rem;

        flex-shrink: 0;
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/CalculatorBanner.vue"],"names":[],"mappings":";AAsBA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,YAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA,oBAAA;;QAAA,8CAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,gDAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,oBAAA;AAAA;AAAA;AAGA;;IAAA,gBAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA,kBAAA;;QAAA,uDAAA;;QAAA,oBAAA;;QAAA,8CAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,uDAAA;;IAAA,oBAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,mBAAA;;QAAA,sBAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA,sBAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,UAAA;;IAAA,aAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,kBAAA;;IAAA,+LAAA;;IAAA,6BAAA;;IAAA,gCAAA;;IAAA,kBAAA;;IAAA,yDAAA;AAAA;AAAA;AAAA;;QAAA,cAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,cAAA;;QAAA,YAAA;;QAAA,YAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,UAAA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA,gDAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA,mBAAA;;QAAA,gBAAA;AAAA;AAAA;AAIA;;IAAA,YAAA;;IAAA,aAAA;;IAAA,YAAA;AAAA;AAIA;AAAA;;QAAA,mBAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,eAAA;;IAAA,gBAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;AAAA;AAAA;AAIA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA,gBAAA;AAAA;AAAA;AAAA;;QAAA,oBAAA;AAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,qBAAA;;IAAA,kBAAA;;IAAA,eAAA;AAAA;AAAA;;IAAA,cAAA;AAAA;AAAA;;IAAA,yBAAA;;IAAA,cAAA;AAAA;AAAA;;IAAA,yBAAA;;IAAA,cAAA;AAAA;AAAA;;IAAA,yBAAA;AAAA;AAAA;;IAAA,WAAA;AAAA;AAAA;AAAA;;QAAA,uBAAA;;QAAA,kBAAA;AAAA;AAAA;AAAA;;IAAA,yBAAA;;IAAA,gBAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA,iBAAA;;IAAA,mBAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA,eAAA;AAAA;AAAA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA,cAAA;;IAAA,WAAA;;IAAA,gBAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA,iBAAA;;QAAA,eAAA;;QAAA,cAAA;AAAA;AAAA","sourcesContent":["<template>\n  <section class=\"calculator\">\n    <div class=\"calculator__container\">\n      <div class=\"calculator__wrapper\">\n        <div class=\"calculator__mole\"></div>\n        <div class=\"calculator__content\">\n          <img class=\"calculator__image\" src=\"img/web/calculadora.svg\" alt=\"calculadora\" />\n          <div class=\"calculator__body\">\n            <h2 class=\"calculator__title\">Calculadora</h2>\n            <p class=\"calculator__text\">\n              ¿Sólo quieres saber qué hipoteca te puedes permitir? Introduce tus datos y te lo decimos rápido.\n            </p>\n          </div>\n          <a class=\"calculator__cta\" :href=\"route('calculator.view')\">Calcular mi hipoteca</a>\n        </div>\n      </div>\n    </div>\n  </section>\n</template>\n\n<style scoped lang=\"postcss\">\n.calculator {\n  @apply container container-thin py-xl sm:py-xxl;\n\n  &__container {\n    @apply overflow-hidden lg:rounded-md lg:border-solid lg:border-thin lg:text-support-dark lg:bg-support-dark;\n  }\n\n  &__wrapper {\n    @apply relative rounded-md stretch-xs lg:py-lg 2xl:px-giant bg-support-dark lg:rounded-none;\n  }\n\n  &__mole {\n    @apply absolute z-0 hidden rotate-45 lg:block bg-neutral-white w-[296px] 2xl:w-[432px] h-[290px] rounded-l-[260px] bottom-[-98px] 2xl:bottom-[-153px] right-[-98px] 2xl:right-[-57px];\n  }\n\n  &__content {\n    @apply relative z-0 text-center lg:flex lg:items-center text-neutral-white lg:text-left;\n  }\n\n  &__image {\n    @apply m-auto w-[102px] h-[102px];\n  }\n\n  &__body {\n    @apply lg:ml-xxs;\n  }\n\n  &__title {\n    @apply mt-xxs lg:mt-0 style-title-sm-bold;\n  }\n\n  &__text {\n    @apply mx-auto mt-nano style-body max-w-[17.5rem] lg:max-w-[26.375rem];\n  }\n\n  &__cta {\n    @apply block w-full mx-auto mt-sm lg:mt-0 lg:ml-xxl btn btn-lg btn-primary max-w-content lg:w-[13.25rem] lg:shrink-0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
